import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './FunctionDetails.css';

// 静态资源版本号，用于避免浏览器缓存老图片
const ASSET_VERSION = Date.now();

const FunctionDetails = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  return (
    <section className="function-details" id="function-details" ref={ref}>
      <div className="container">
        <motion.div
          className="function-details-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="function-details-title">功能介绍</h2>
        </motion.div>

        <motion.div
          className="function-images-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {/* 第一组：拆图1-1和1-2横向拼接 */}
          <motion.div 
            className="function-image-item paired-images-unified"
            variants={itemVariants}
          >
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/1-1.png?v=${ASSET_VERSION}`}  />
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/1-2.png?v=${ASSET_VERSION}`} />
          </motion.div>

          {/* 图片2和图片4横向拼接 */}
          <motion.div 
            className="function-image-item paired-images-unified"
            variants={itemVariants}
          >
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/2-1.png?v=${ASSET_VERSION}`} />
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/2-2.png?v=${ASSET_VERSION}`}  />
          </motion.div>

          {/* 第二组：拆图2-1和2-2横向拼接 */}
          <motion.div 
            className="function-image-item paired-images-unified"
            variants={itemVariants}
          >
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/3-1.png?v=${ASSET_VERSION}`}  />
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/3-2.png?v=${ASSET_VERSION}`}  />
          </motion.div>

          {/* 完整图片3 */}
          <motion.div 
            className="function-image-item single-image"
            variants={itemVariants}
          >
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/4.png?v=${ASSET_VERSION}`} />
          </motion.div>

          {/* 第三组：拆图3-1和3-2横向拼接 */}
          <motion.div 
            className="function-image-item paired-images-unified"
            variants={itemVariants}
          >
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/5-1.png?v=${ASSET_VERSION}`} />
            <img src={`${process.env.PUBLIC_URL}/images/功能介绍/5-2.png?v=${ASSET_VERSION}`} />
          </motion.div>
        </motion.div>
      </div>

      {/* 背景装饰 */}
      <div className="function-details-background">
        <div className="bg-gradient bg-gradient-1"></div>
        <div className="bg-gradient bg-gradient-2"></div>
      </div>
    </section>
  );
};

export default FunctionDetails;

